import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { AngularLoginComponent } from './angular-login.component';
import { CommonModule } from '@angular/common';

@NgModule({
    imports: [ CommonModule, ReactiveFormsModule ],
    declarations: [ AngularLoginComponent ],
    exports : [ AngularLoginComponent ],
    providers: []
})
export class AngularLoginModule { 

}


// WEBPACK FOOTER //
// ./src/angular_library/components/login/angular-login.module.ts